import taskStateOptions from "@coworker/enums/taskState";

const { CLOSED, COMPLETED, UNASSIGNED, ASSIGNED } = taskStateOptions;

export function isFinishedState(state) {
  return [CLOSED, COMPLETED].includes(state);
}

export function isAssignedOrUnassigned(state) {
  return [UNASSIGNED, ASSIGNED].includes(state);
}
